var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import { CaseApplyRecordService } from "~/services/domain-service/case-apply-record.service";
var CaseApprovalCommon = /** @class */ (function (_super) {
    __extends(CaseApprovalCommon, _super);
    function CaseApprovalCommon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitLoading = false;
        _this.rules = {
            applyStatus: [{ required: true, message: "请选择审批状态" }],
            approvalOpinion: [{ required: true, message: "请输入审批意见" }]
        };
        _this.applyModel = {
            applyStatus: "PASS",
            approvalOpinion: "",
            id: ""
        };
        _this.recordHistory = [];
        _this.loading = false;
        return _this;
    }
    CaseApprovalCommon.prototype.idChange = function (value) {
        var _this = this;
        this.applyModel.id = value.id;
        this.caseApplyRecordService
            .recordHistory({ applyId: value.id })
            .subscribe(function (data) {
            _this.recordHistory = data;
        });
    };
    CaseApprovalCommon.prototype.close = function () {
        this.reset();
    };
    Object.defineProperty(CaseApprovalCommon.prototype, "userId", {
        get: function () {
            return this.userData.id;
        },
        enumerable: false,
        configurable: true
    });
    CaseApprovalCommon.prototype.reset = function () {
        var form = this.$refs["form"];
        form.resetFields();
    };
    CaseApprovalCommon.prototype.commit = function (applyStatus) {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (result) {
            if (!result)
                return;
            _this.applyModel.applyStatus = applyStatus;
            if (applyStatus === 'PASS')
                _this.submitLoading = true;
            else
                _this.loading = true;
            _this.caseApplyRecordService.dealApply(_this.applyModel).subscribe(function (data) {
                _this.loading = false;
                _this.submitLoading = false;
                _this.$message.success("审批成功");
                _this.close();
            }, function (err) {
                _this.submitLoading = false;
                _this.loading = false;
            });
        });
    };
    /**
     * 附件查看
     */
    CaseApprovalCommon.prototype.annexCheckClick = function (row) {
        window.open(row.url, row.fileName);
    };
    CaseApprovalCommon.prototype.pauseDueTimeChange = function () { };
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], CaseApprovalCommon.prototype, "caseApplyRecordService", void 0);
    __decorate([
        State
    ], CaseApprovalCommon.prototype, "userData", void 0);
    __decorate([
        Prop({ required: true })
    ], CaseApprovalCommon.prototype, "rowData", void 0);
    __decorate([
        Watch("rowData", { immediate: true })
    ], CaseApprovalCommon.prototype, "idChange", null);
    __decorate([
        Emit("close")
    ], CaseApprovalCommon.prototype, "close", null);
    CaseApprovalCommon = __decorate([
        Component({
            components: {}
        })
    ], CaseApprovalCommon);
    return CaseApprovalCommon;
}(Vue));
export default CaseApprovalCommon;
